import { RouterProvider, createBrowserRouter } from "react-router-dom";
import DashboardPage from "../../pages/dashboard";
import InsightPage from "../../pages/insights";
// import CompanyProfile from "../../pages/companyProfile/companyProfile";
import "./app.scss";
import UserLayout from "../../layouts/user-layout";
import ProfilePage from "../../pages/profile/profile";
import GuestHomePage from "../../guest/pages/guest-home/guest-home";
import GuestLayout from "../../layouts/guest-layout/guest-layout";
import ProductList from "../../guest/pages/product-list/product-list";
import SubscriptionPlan from "../../guest/pages/subscription-plan/subscription-plan";
import Solutions from "../../guest/pages/solutions/solutions";
import WhyUs from "../../guest/pages/why-us/why-us";
import GuestLogin from "../../guest/pages/guest-login/guest-login";
import GuestSignup from "../../guest/pages/guest-signup/guest-signup";
import SignupLayout from "../../layouts/signup-layout/signup-layout";
import BasicCompanyInfo from "../../signup/pages/basic-company-info/basic-compnay-info";
import MoreCompanyInfo from "../../signup/pages/more-company-info/more-company-info";
import CompanyOtherInfo from "../../signup/pages/company-other-info/company-other-info";
import { basename } from "path";
import AboutCompany from "../../signup/pages/about-company/about-company";
import CreateAccount from "../../guest/pages/create-account/create-account";
import RegistrationConfirmation from "../../guest/pages/registration-confirmation/registration-confirmation";
import RegistrationVerification from "../../guest/pages/registration-verification/registration-verfication";
import AdminApproveRejectUser from "../../guest/pages/admin-approve-reject/admin-approve-reject";
import OnboardLayout from "../../layouts/onboard-layout/onboard-layout";
import CompanyOnboard from "../../signup/pages/company-onboard/company-onboard";
import axios from "axios";
import WorkspacePage from "../../pages/workspace/workspace";
import CompanyProfilePage from "../../pages/companyProfile/companyProfile";
import GoalsPage from "../../pages/goals/goals";
import DesignerStudioPage from "../../pages/designer-studio";
import AboutUs from "../../guest/pages/about-us/about-us";

// Http interceptor
axios.interceptors.request.use(
  (config:any) => {

    let isWhitelistedUrl: boolean = false;
    const whitelistedUrls: string[] = ["https://maps.googleapis.com"];
    whitelistedUrls.forEach(url=>{
      if(config.url.includes("maps.googleapis.com")){
        isWhitelistedUrl = true;
        return;
      }
    });

    if(isWhitelistedUrl) return config;

    const token = sessionStorage.getItem("access_token");
    if (token) { 
      
      config.headers.Authorization = `Bearer ${token}`;
      console.log("Access token ", token);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const App = () => {
  const trowelRouter = createBrowserRouter([
    {
      path: "/",
      element: <GuestLayout />,
      children: [
        { path: "/", element: <GuestHomePage /> },
        { path: "/about-us", element: <AboutUs /> },
        { path: "/products", element: <ProductList /> },
        { path: "/pricing", element: <SubscriptionPlan /> },
        { path: "/solution", element: <Solutions /> },
        { path: "/whyus", element: <WhyUs /> },
        { path: "/resources", element: <ProfilePage /> },
        { path: "/create-account", element: <CreateAccount /> },
        { path: "/login", element: <GuestLogin /> },
        { path: "/signup", element: <GuestSignup /> },
        {
          path: "/registration-confirmation",
          element: <RegistrationConfirmation />,
        },
        {
          path: "/registration-verification",
          element: <RegistrationVerification />,
        },
        {
          path: "/admin-approve-reject",
          element: <AdminApproveRejectUser />,
        },
      ],
    },
    {
      path: "/",
      element: <OnboardLayout />,
      children: [
        { path: "/company-onboard", element: <CompanyOnboard /> },
        // { path:'/signup-s2', element:<MoreCompanyInfo/>},
        // { path:'/signup-s3', element:<CompanyOtherInfo/>},
        // { path:'/signup-s4', element:<AboutCompany/>}
      ],
    },
    {
      path: "/",
      element: <SignupLayout />,
      children: [
        { path: "/signup-s1", element: <BasicCompanyInfo /> },
        { path: "/signup-s2", element: <MoreCompanyInfo /> },
        { path: "/signup-s3", element: <CompanyOtherInfo /> },
        { path: "/signup-s4", element: <AboutCompany /> },
      ],
    },
    {
      path: "/",
      element: <UserLayout />,
      children: [
        { path: "/dashboard", element: <DashboardPage /> },
        { path: "/insight", element: <InsightPage /> },
        { path: "/goals", element: <GoalsPage /> },
        { path: "/profile", element: <CompanyProfilePage /> },
        { path: "/workspace", element: <WorkspacePage /> },
        { path: "/designer-studio", element: <DesignerStudioPage /> },
      ],
    },

    // Dashboard layout

    // {
    //   path : "/",
    //   element: <UserLayout />, // Create Guest layout and replacce UserLayout
    //   children: [ // Create route for Guest layout
    //     { path: "/dashboard", element: <DashboardPage /> },
    //     { path: "/insight", element: <InsightPage /> },
    //     { path: "/goal", element: <GoalsPage /> },
    //     { path: "/profile", element: <ProfilePage/>},
    //   ],
    // },
  ]);
  return <RouterProvider router={trowelRouter} />;
};

export default App;
